<script setup lang="ts">
import ReportState, { type PhotosViewMode } from "@/stores/report/ReportState";
import { computed } from "vue";

const activeMode = computed(() => ReportState.photosViewMode);

const setMode = (mode: PhotosViewMode) => {
  ReportState.setPhotosViewMode(mode);
};

const modes: { id: PhotosViewMode; label: string; icon: string }[] = [
  {
    id: "gallery",
    label: "report:photos.viewMode.gallery",
    icon: "bi-grid-3x3-gap",
  },
  {
    id: "details",
    label: "report:photos.viewMode.details",
    icon: "bi-list-ul",
  },
];
</script>

<template>
  <div class="view-mode-toggle d-flex gap-1">
    <button
      v-for="mode in modes"
      :key="mode.id"
      class="mode-btn d-flex align-items-center gap-1 px-2 py-1 border-0 rounded"
      :class="{ active: activeMode === mode.id }"
      @click="setMode(mode.id)"
    >
      <el-icon size="14"><i :class="mode.icon"></i></el-icon>
      <span>{{ $t(mode.label) }}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import "@/style/variables.scss";

.view-mode-toggle {
  display: inline-flex;
}

.mode-btn {
  background: transparent;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(.active) {
    color: #6b7280;
  }

  &.active {
    color: var(--bs-primary);
    background-color: var(--el-color-primary-light-9);
  }
}
</style>
